import { render, staticRenderFns } from "./LiveJournalButton.vue?vue&type=template&id=7a5dd8c7&scoped=true&"
import script from "./LiveJournalButton.vue?vue&type=script&lang=js&"
export * from "./LiveJournalButton.vue?vue&type=script&lang=js&"
import style0 from "./LiveJournalButton.vue?vue&type=style&index=0&id=7a5dd8c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5dd8c7",
  null
  
)

export default component.exports